export default __webpack_public_path__ + "static/fo-f9131f7a7ffa1298bec641b75ba386bc.svg";